import React from 'react';
import { GitHubReviewer, CurrentUserIdentity } from '../../domain/types';
import { Accordion, Pill, Avatar, Button } from '../../ui/common';

export interface GitHubReviewersSectionProps {
  reviewers?: GitHubReviewer[];
  isCurrentUserApproved: boolean;
  merged?: boolean;
  currentUser?: CurrentUserIdentity;
  onApprovePR: (e: React.MouseEvent) => void;
}

export const GitHubReviewersSection: React.FC<GitHubReviewersSectionProps> = ({
  reviewers = [],
  isCurrentUserApproved,
  merged = false,
  currentUser,
  onApprovePR,
}) => {
  if (!reviewers || reviewers.length === 0) return null;

  return (
    <Accordion title="Revisión" defaultOpen={true}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {reviewers.map((r, rIdx) => {
            const revTone = r.state === 'Aprobado' ? 'ok' : r.isCurrentUser ? 'warn' : 'flat';
            return (
              <div
                key={rIdx}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 9,
                  padding: '7px 10px',
                  borderRadius: 9,
                  background: 'var(--z-plate)',
                  border: 'none',
                }}
              >
                <Avatar
                  initials={r.user.initials || 'US'}
                  color={r.user.color || 'var(--z-muted)'}
                  size={24}
                />
                <span style={{ flex: '1 1 auto', minWidth: 0, fontSize: 12, fontWeight: 600, color: 'var(--z-text-3)' }}>
                  {r.user.name || r.user.login}
                </span>
                <Pill label={r.state} tone={revTone} />
              </div>
            );
          })}
        </div>

        {!isCurrentUserApproved && !merged && (
          <div style={{ marginTop: 4 }}>
            <Button variant="ghost" size="sm" onClick={onApprovePR}>
              ✓ {currentUser?.displayName ? `Aprobar revisión como ${currentUser.displayName}` : 'Aprobar revisión (tú)'}
            </Button>
          </div>
        )}
      </div>
    </Accordion>
  );
};
